<template>
	<div class="tipheader">
		<div class="tip_b" :style="{borderBottom: borderNo?'0px':''}">
			<div class="tip_left">
				<div>
					<div class="title">
						<span class="a">{{maxtitle}}</span>
						<span class="b">{{mintitle}}</span>
					</div>
					<div class="linebox">
						<div class="en">{{linTxt?linTxt:'The headlines'}}</div>
						<div class="line"></div>	
					</div>
				</div>
				<div>
					<img src="../static/img/bowimg@2x.png" alt=""/>
				</div>
			</div>
			
			<div class="tip_right">
				<img v-if="ifimg" src="../static/img/rightarrow@2x.png" alt="" @click="seemore"/>
			</div>				
		</div>
		
		
	</div>
	
	
	
</template>

<script>


export default {
  props:['maxtitle','mintitle','ifimg','width','pathUrl','sign','linTxt','borderNo'],
  
  data: function() {
    return {
       
	  
    };
  },
  
  methods: {
		seemore(){
			if(this.pathUrl){ 
				this.$router.push({path:this.pathUrl})
				return
			}
			if(this.sign == '1'){
				this.$router.push({ path: '/gloriousedit' });
			}else if(this.sign == '2'){
				this.$router.push({ path: '/networkroom' });
			}else if(this.sign == '3'){
				this.$router.push({ path: '/excellentcases' });
			}
		
		},
		
  },
  
  mounted() {

	   
  }
  
};
</script>

<style scoped=" scoped" lang="scss">
	
.tipheader{
	
	.tip_b{
		border-bottom: 1px solid #ededed;
		display: flex;
		justify-content: space-between;
		.tip_left{
			display: flex;
			position: relative;
			.title{
				.a{
					font-size: 38px;
					font-weight: 400;
					color: #FA9E1E;
				}
				.b{
					font-size: 28px;
					font-weight: 400;
					color: #010101;
				}
			}
			.linebox{ 
				margin-right: 5px;
				.en{
					font-size: 16px;
					font-weight: 400;
					color: #BDBDBD;
					margin-bottom: 5px;
				}
				
				.line{
					min-width: 131px;
					height: 12px;
					background: #E61F26;
				}
			}
			
			img{
				position: absolute;
				height:69px;
				width:27px;
				bottom: -10px;
			}
		}
		.tip_right{
			display: flex;
			align-items: center;
			img{
				cursor: pointer;
				height: 20px;
				width: 107px;
			}
		}							
	}
	
	
	
}

</style>
